module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18yaoky/tc-custom/9781423614456.jpg?1736882906867",
      "alt": "This image is the cover for the book 101 Things To Do With Popcorn, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Popcorn, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("You will positively pop with excitement for these delightful, tasty popcorn recipes.")]), _c('br'), _c('br'), _vm._v(" The world’s favorite snack just got tastier! These sweet and savory treats will turn this old-fashioned staple into Snickerdoodle Popcorn, Pumpkin Balls, Caramel Nut Bars, Sleepover Mix, Taco Spice, and A Taste of Asia. For a popper of a surprise, give CinnaPop Cake, Popcorn Brownies, Rooster Snacks, Chicken Nuggets, and Swedish Meatballs a try. And don’t forget amazing Snow Balls, Double Berry Bars, Gyro Goodness, Vanilla Pop ’n’ Nuts, Chocolate-Coated Brittle, Poppin’ Muffins, and More!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christina Dymock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Christina Dymock graduated from the University of Utah in communications and has worked as an editor. She lives with her husband and four children in Utah. This is her first book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0